import React from "react";
import Loading from "../../Loading.js";
import Paper from "material-ui/Paper";
import * as actions from '../../../store/actions/index';
import { connect } from "react-redux";
import ShareDialog from "../../ShareDialog.js";
import { domain, secretKey, facebook_appId, mppl_redirect_uri, baseUrl, partyBrands } from "../../../common/config.js";
import queryString from "query-string";
import moment from "moment";
import { Redirect } from "react-router";
import { apiService } from '../../../common/apiCallService.js'
import { saveActivity, processHoleCards,updateOnBoard } from "../../../common/commonService";
import HandReplayer from "../../HandReplayer/HandReplayer";
import ReplayHand from "../../HandReplayer/ReplayHand";
import MediaQuery from 'react-responsive';
import { DispatcherFunction } from 'mygame-components';
import * as htmlToImage from 'html-to-image';
import i18next from 'i18next'
import {
    ReportCardFilter,
    ReportHeading,
    ReportSummary,
    ReportCardContent,
    ReportSummaryMessage,
    ShareToSocialMedia,
    MissionAlert,
    MyTopHandsWrapper,
    NewPromotionsWrapper,
    NewShareToSocialMedia,
    ShareReportCardModal
} from "mygame-components";
import OnBoard from '../../MygameOnBoard/OnBoard';
import '../../../../node_modules/mygame-components/src/css/reportCard.css'
import '../../../../node_modules/mygame-components/src/css/PlayerReportCard.css'
import '../../../../node_modules/mygame-components/src/css/PlayerReportCardBeta.css'
import '../../../../node_modules/mygame-components/src/css/UI.css'
import '../../../../node_modules/mygame-components/src/css/PlayerLevel.css'
import '../../../../node_modules/mygame-components/src/css/resp-table.css'
import '../../../../node_modules/mygame-components/src/css/MissionAlert.css'
import '../../../../node_modules/mygame-components/src/css/newPlayerReportCard.css'
import '../../../../node_modules/mygame-components/src/css/newReportCardMyTopHands.css'
import '../../../../node_modules/mygame-components/src/css/NewReportCardPromotions.css'
import { getColor, getDarkTextColor, getHoverColor, getTextColor } from "../../../common/ThemeService.js";
// import ShareReportCardModal from "../ShareReportCardModal.js";
// import NewShareToSocialMedia from "./NewShareToSocialMedia.js";
let _ = require("lodash"),
    fullVersion = 0,
    Logo = "//" + domain + "/images/common/loadingNew.gif";

class NewPlayerReportCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            title: 'Report Card',
            accountName: props.match.params.accountName,
            reportSettingsOpen: false,
            shareDialogOpen: false,
            shareTrack: {},
            screenshot: '',
            access: JSON.parse(localStorage.getItem('userRole')),
            loading: false,
            redirectUrl: '/',
            loginRedirect: false,
            shareIcon: '//' + domain + '/images/shareIcon.jpg',
            redirect: false,
            openHandRep: false,
            shareId: '',
            shareLink: '',
            openSocialMediaDialog: false,
            banner_url: '',
            stars: '',
            copiedLink: "",
            showMission: false,
            handDtls: {},
            isOnBoard: localStorage.getItem('mygame_onboarded') === 'N' ? 1 : 0,
            openReportCardShareModal:false,
            shareObj:{},
            analysisArray:[],
            selectedSummeryRange:[],
            replModal:null,
            brand:localStorage.getItem('loggedInType')
        }
        const { hitRange, hitType, hitLevel, fromDate, toDate, shift = 'Select' } = queryString.parse(this.props.location.search);
        let { gameType, accountName } = props.match.params,
            plyerReportSetting = (this.props.reportCardSetting.filter(plyReportSetting => plyReportSetting.gameType === gameType)[0])

        plyerReportSetting = plyerReportSetting.hitRange === 'Select' || this.props.history.action === 'POP'
            ? { ...plyerReportSetting, ...{ gameType, fromDate, toDate, accountName, shift, hitRange, hitType, hitLevel } }
            : this.props.multiGamePlayerReports.filter(game => game.gameType === gameType)[0]
        if (plyerReportSetting)
            this.props.getOnLoadReportCardDtls(plyerReportSetting)

    }

    handleToggleSwith = (item) => {
        const {selectedSummeryRange, analysisArray} = this.state;
        let index = selectedSummeryRange.findIndex((data)=>item.category === data.category);
        if (index !== -1) {
            let analysisIndex = analysisArray.findIndex((data)=>data === item.category);
            if(analysisIndex !== -1) {
                analysisArray.splice(analysisIndex,1);
            }
            selectedSummeryRange[index].enable = !selectedSummeryRange[index].enable;
            this.setState({
                selectedSummeryRange,
                analysisArray
            })
        }
    }

    componentWillReceiveProps = async (nextProps) => {
        if (nextProps.playerReports.hands < 100 && this.props.playerReports.hands != nextProps.playerReports.hands) {
            this.setState({ redirect: true })
        }
        fullVersion = await this.getDeviceVersion()
    }

    disableOnBoard = async () => {
        this.setState({ loading: true, isOnBoard: 0 })
        await updateOnBoard()
        this.setState({ loading: false })
    }

    handReplayerOpen = (handReply) => {
      saveActivity({
        hit_page: 'ReportCard',
        hit_type: 'ReportCardGameReplay',
        hit_attribute1: handReply.gameNo,
        hit_attribute2: this.props.match.params.gameType,
      })
      
        handReply.partitionDate = handReply.time;
        if(window.messageToNative || (window.external && window.external.NativeDispatch)){
        DispatcherFunction("app:menu=3814&name=MYGAME_REPLAYER",{
            "MYGAME_REPLAYER_URL":'https://' + window.location.hostname +
            `/PopUpHandReplayer/${this.props.gameType}/${handReply.gameNo}/${this.state.accountName}/${handReply.fullDateTime? handReply.fullDateTime: handReply.time}` ,
            "location":"yes",
            "height":"720",
            "width":"1000",
            "scrollbars":"yes",
            "status":"yes"
      })}
        else{
        this.setState({
            gameNo: handReply.gameNo,
            partitionDate: handReply.partitionDate,
            handDtls: handReply,
            openHandRep: true
        });
        this.forceUpdate();
    }        
    };

    setStarFlagOfHnad = (hand, newStarValue, handListType) => {
        // update local data
        let newTopHands = this.props.playerReports.topHands;
        if(handListType === "won") {
          let newTopWonHands = newTopHands.topWonHands.map(handObj=>{
            if(hand.gameNo.toString() === handObj.gameNo.toString()) {
              return {...handObj, staredHand: newStarValue}
            } else {
              return handObj;
            }
          })
          newTopHands.topWonHands = newTopWonHands
        } else {
          let newTopLostHands = newTopHands.topLostHands.map(handObj=>{
            if(hand.gameNo.toString() === handObj.gameNo.toString()) {
              return {...handObj, staredHand: newStarValue}
            } else {
              return handObj;
            }
          })
          newTopHands.topLostHands = newTopLostHands
        }
        
        this.props.setTopHands(newTopHands);
        this.forceUpdate();
    
        // api call to set star
        let reqObj = {
            staredHand: newStarValue,
            accountName: localStorage.getItem("accountName"),
            gameType: this.props.gameType,
            gameNo: hand.gameNo,
            time: hand.time,
            // SB: hand.SB,
            // BB: hand.BB,
            // ringType: hand.ringType,
            // gameSubType: hand.gameSubType,
            // holeCards: hand.holeCards,
        }
        apiService(baseUrl + '/handInfo/setStarFlagOfHandInfo', reqObj, (data) => {
            this.setState({ loading: false });
            saveActivity({
                hit_page: 'ReportCard',
                hit_type: 'FavouriteHand',
                hit_attribute1: this.props.gameType,
                hit_attribute2: newStarValue,
                hit_attribute3: hand.gameNo,
                hit_attribute4: hand.time
            })
        }, (error) => {
            console.log("Error", error)
            this.setState({ loading: false })
        })
      }

    getDeviceVersion = async () => {
        try {
            // console.log("navigator.appVersion-----------------------")
            // console.log(navigator.appVersion)
            if (navigator.appVersion.indexOf("Mac") >= 0) {
              if (navigator.appVersion.indexOf("Mobile") >= 0) {
                let osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
                fullVersion = parseFloat(osVersion[1] + '.' + osVersion[2] + osVersion[3]);
                if (fullVersion > 12.10) {
                  fullVersion = 13
                } else {
                  fullVersion = 12
                }
              } else {
                let osVersion = /OS X (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
                // console.log("osVersion",osVersion)
                if(osVersion){
                  fullVersion = parseFloat(osVersion[1] + '.' + osVersion[2]);
                  if (fullVersion > 10.13) {
                    fullVersion = 13
                  } else {
                    fullVersion = 12
                  }
                } else {
                  fullVersion = 12
                }
              }
            } else {
              fullVersion = 13;
            }
            return fullVersion;
        } catch (error) {
            console.log(error);
            throw new Error(error)
        }
    }
    saveSettings = (values) => {
        try {
            let defaultReportSettings = {
                playerChangeFilter:true,
                accountName: this.props.match.params.accountName,
                level: 'All Level',
                shift: "Select", hitType: '3 max',
                hitRange: localStorage.getItem('userRole') && JSON.parse(localStorage.getItem('userRole')).indexOf('PLAYER') != -1 ? 'This Year' : 'Select',
            },
                isReportSettingChange = _.isEqual(this.props.formData.reportCardSettingFilter.initial, this.props.formData.reportCardSettingFilter.values)
            if (!isReportSettingChange) {
                if (values.range === 'Select') delete values.range
                if (Object.keys(values).length > 0) {
                    if (values.level) defaultReportSettings.hitLevel = values.level
                    if (values.type) defaultReportSettings.hitType = values.type

                    if (values.range) {
                        defaultReportSettings.hitRange = values.range
                        if (values.range === 'Today') {
                            defaultReportSettings.fromDate = moment().startOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
                            defaultReportSettings.toDate = moment().endOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
                        }
                        else {
                            defaultReportSettings.rangeChange = true
                        }
                    }
                    let settings = {
                        ...(this.props.reportCardSetting.filter(reportFilter => reportFilter.gameType === this.props.gameType)[0]),
                        ...defaultReportSettings
                    }
                    if (values.range === 'Today') {
                        let SB = "All";
                        let BB = "All";
                        if (settings.hitLevel && settings.hitLevel != "All Level") {
                            [SB, BB] = settings.hitLevel.split("/");
                        }
                        let gameDateInfo = moment().format('DD/MM/YYYY');
                        this.props.getSingleReportCardsDetails({
                            ...settings,
                            key: `${gameDateInfo}:${localStorage.getItem("accountname")}:${settings.gameType}:${settings.hitType}:${SB}:${BB}`
                        })
                    } else {
                        this.props.getSingleReportCardsDetails(settings)
                    }
                }
            }
            this.setState({ reportSettingsOpen: false })
        } catch (error) {
            console.log(error)
        }
    }
    getShareId = (data) => new Promise((resolve, reject) => {
        //let { type, banner_url, title, description, hit_attribute1, hit_attribute2, hit_attribute3, hit_attribute4, gameType, level, stars } = data;
        const {summaryRange} =this.props.playerReports;
        let selectedSummeryRange = [];
        let analysis = [];
        summaryRange.map((item)=>{
            item.enable = true;
            analysis.push(item.category.trim());
            selectedSummeryRange.push(item);
        })
        this.setState({
            openReportCardShareModal:true,
            shareObj: data,
            shareId:'',
            analysisArray:analysis,
            selectedSummeryRange:selectedSummeryRange
        })

    })

    getSocialShareId = (reportCardObject) => new Promise((resolve, reject) =>{
        const { shareObj } = this.state;

        let { type, banner_url, title, description, hit_attribute1, hit_attribute2, hit_attribute3, hit_attribute4, gameType, level, stars } = shareObj;
         apiService(
            baseUrl + '/shareLinkMetadata/save',
            { type, banner_url, title, description, attribute1:hit_attribute1, attribute2:hit_attribute2,
                attribute3:hit_attribute3, attribute4:hit_attribute4,attribute5:this.state.brand, reportCardObject:reportCardObject},
            ({ _id: shareId }) => {
                saveActivity({
                    hit_page: 'ReportCard',
                    hit_type: 'ReportCardShareModalOpened',
                    hit_attribute1: shareId,
                    hit_attribute2: gameType,
                    hit_attribute3: level,
                    hit_attribute4: stars,
                    hit_attribute5: this.state.brand,
                    reportCardObject:reportCardObject
                })
                this.setState({
                    shareId,
                    shareLink: `https://${domain}/share/reportcard?id=${shareId}`,
                    openSocialMediaDialog: true,
                    stars: stars,
                    banner_url: banner_url
                })
                this.forceUpdate()
                resolve()
            },
            reject()
        )
    })
    loadImage = () => new Promise((resolve, reject) => {
        var node = document.getElementById('viewShareReportCardId');
        htmlToImage.toPng(node)
        .then(function (dataUrl) {
            var img = new Image();
            img.src = dataUrl;
            resolve(img.src);
        })
        .catch(function (error) {
            console.error('oops, something went wrong!', error);
        });
    })
    shareOnFacebook = async () => {
        const { shareId, shareLink } = this.state;
        //let dataUrl = await this.loadImage();
        saveActivity({
            hit_page: 'ReportCard',
            hit_type: 'ReportCardLinkShared',
            hit_attribute1: shareId,
            hit_attribute2: this.props.playerReports.gameType,
            hit_attribute3: this.props.playerReports.summaryInfo[0].medal,
            hit_attribute4: this.props.playerReports.star,
            hit_attribute5: 'facebook',
        })
        if (window.messageToNative || (window.external && window.external.NativeDispatch)) {
            window.open(
                `https://www.facebook.com/dialog/share?app_id=${facebook_appId}&display=popup&href=${encodeURIComponent(shareLink + `&source=facebook`)}`,
                '_blank'
            )
        } else {
            window.open(
                `https://www.facebook.com/dialog/share?app_id=${facebook_appId}&display=popup&href=${encodeURIComponent(shareLink + `&source=facebook`)}`,
                '_blank',
                'width=600,height=400'
            )
        }
        this.closeShareModalAndSocial();
    }

    onNextClick = async () => {
        const {playerReports} = this.props
        const { selectedSummeryRange, analysisArray } = this.state;
        let stats = analysisArray.join();
        saveActivity({
            hit_page: 'ReportCard',
            hit_type: 'ReportCardStats',
            hit_attribute1: this.props.gameType,
            hit_attribute2: stats,
        })
      //  const result = selectedSummeryRange.filter((item) => item.enable);
        const playerStatsResult =  playerReports.playerStats.filter((item)=>analysisArray.includes(item.category) )
        let reportCardObject = {
           summeryRange:selectedSummeryRange,
           playerStats: playerStatsResult,
           hands:playerReports.hands,
           summaryInfo:playerReports.summaryInfo[0],
           luckfactor:playerReports.luckfactor,
           accountName:this.state.accountName,
           playerName:localStorage.getItem("first_name") || localStorage.getItem("alias"),
           lastReportUpdatedDate:new Date(),
           star:playerReports.star,
           gameType:this.props.gameType
       }
       if(this.state.shareId === "") {
        await this.getSocialShareId(reportCardObject);
       }
        this.setState({
            openSocialMediaDialog:true
        })

    }
    closeShareModalAndSocial = () => {
        this.setState({
            openReportCardShareModal:false,
            openSocialMediaDialog:false,
            copiedLink: "" 
        })
    }
    shareOnTwitter = () => {
        const { shareId, shareLink } = this.state;
        saveActivity({
            hit_page: 'ReportCard',
            hit_type: 'ReportCardLinkShared',
            hit_attribute1: shareId,
            hit_attribute2: this.props.playerReports.gameType,
            hit_attribute3: this.props.playerReports.summaryInfo[0].medal,
            hit_attribute4: this.props.playerReports.star,
            hit_attribute5: 'twitter',
        })
        this.closeShareModalAndSocial();
        if (window.messageToNative || (window.external && window.external.NativeDispatch)) {
            window.open(
                `https://twitter.com/share?url=${encodeURIComponent(shareLink + '&source=twitter')}&&text=check your score on&&via=partypoker`,
                '_blank'
            )
        } else {
            window.open(
                `https://twitter.com/share?url=${encodeURIComponent(shareLink + '&source=twitter')}&&text=check your score on&&via=partypoker`,
                '_blank',
                'width=600,height=400'
            )
        }
    }

    shareModal_close = () => this.setState({ openSocialMediaDialog: false, copiedLink: "", openReportCardShareModal:false })
    handleClose  = () => this.setState( {openReportCardShareModal:false });
    saveCourseRedirection =(category,lessonName,stat,grade)=>{
        saveActivity({
            hit_page: 'ReportCard',
            hit_type: 'CategoryLesson',
            hit_attribute1: category,
            hit_attribute2: stat,
            hit_attribute3: lessonName,
            hit_attribute3: this.props.playerReports.gameType,
            hit_attribute4: grade
            })
    };
    render() {
        const themeColor = getColor();
        const themeTextColor = getTextColor();
        const themeDarkTextColor = getDarkTextColor();
        const themeHoverColor = getHoverColor();
        const queryParams = queryString.parse(this.props.location.search),
            { playerReports, reportCardSetting, medalsDetails, gameType, starsDetails } = this.props,
            showShareModal = this.state.openSocialMediaDialog ? 'displayBlock' : 'displayNone';
        this.props.setHeaderTitle(this.state.title);
        let { fromDate, toDate, hitLevel, hitRange, hitType, accountName, shift } = this.props.reportCardSetting.filter(plyReportSetting => plyReportSetting.gameType === gameType)[0];
        console.log("shareId",this.state.shareId);
        // if(this.state.openSocialMediaDialog){
        //     return <div>
        //     <ViewSharedReportCard shareId={this.state.shareId}/>
        //     <NewShareToSocialMedia
        //                         open ={this.state.openSocialMediaDialog}
        //                         handleClose = {this.handleClose}
        //                             stars={this.state.stars}
        //                             banner_url={this.state.banner_url}
        //                             showShareModal={showShareModal}
        //                             shareModal_close={this.shareModal_close}
        //                             shareOnTwitter={this.shareOnTwitter}
        //                             shareOnFacebook={this.shareOnFacebook}
        //                             shareLink={this.state.shareLink}
        //                             copiedLink={this.state.copiedLink}
        //                             setCopiedLink={(shareLink) => {
        //                                 this.setState({ copiedLink: shareLink })
        //                             }}
        //                         />
        // </div>
        // }
        return (
            <div>
                <style>
                    {`.shareLevel, .levelInfo {\
                            background-color: ${themeColor} !important;\ 
                            border-color: ${themeColor} !important;\
                            color: ${themeTextColor} !important;\
                        }\
                    `}
                    {` a.mg-btn.saffron.liviviewLessonBtn.reportCardLessonLink {\
                            background-color: #ffffff !important;\ 
                            color: ${themeDarkTextColor} !important;\
                            border-color: ${themeColor} !important;\
                        }\
                    `}
                    {`.closeButtonhoverEffect:hover, a.mg-btn.saffron.liviviewLessonBtn.reportCardLessonLink:hover {\
                            background-color: ${themeHoverColor} !important;\ 
                        }\
                        `}
                    {`.shareLevel:hover, .levelInfo:hover {\
                            background-color: ${themeHoverColor} !important;\ 
                            color: ${themeDarkTextColor} !important;\
                        }\
                    `}
                    {`.toggle-switch-label {\
                        border-color: ${themeColor};\
                    }\
                    .toggle-switch-switch {\
                        background-color: ${themeColor};\
                    }\
                    `}
                </style>
              {this.state.openSocialMediaDialog && <NewShareToSocialMedia
                                    i18next={i18next}
                                    open ={this.state.openSocialMediaDialog}
                                    handleClose = {this.handleClose}
                                    stars={this.state.stars}
                                    banner_url={this.state.banner_url}
                                    showShareModal={showShareModal}
                                    shareModal_close={this.shareModal_close}
                                    shareOnTwitter={this.shareOnTwitter}
                                    shareOnFacebook={this.shareOnFacebook}
                                    shareLink={this.state.shareLink}
                                    copiedLink={this.state.copiedLink}
                                    setCopiedLink={(shareLink) => {
                                        saveActivity({
                                            hit_page: 'ReportCard',
                                            hit_type: 'ReportCardLinkShared',
                                            hit_attribute2: this.props.playerReports.gameType,
                                            hit_attribute3: this.props.playerReports.summaryInfo[0].medal,
                                            hit_attribute4: this.props.playerReports.star,
                                            hit_attribute5: 'copylink'
                                        })
                                        this.setState({ copiedLink: shareLink })
                                    }}
                                />
    }
                {this.state.isOnBoard ==1 && JSON.parse(localStorage.getItem('userRole')).indexOf('PLAYER') != -1  && <OnBoard  disableOnBoard={this.disableOnBoard}/>}
                {(this.props.loading || this.state.loading) && <Loading />}
                {this.state.redirect ?
                    (queryParams.source && queryParams.source === 'mygamelive'
                        ? <Redirect to={'/SkillLevel?logintype=player&source=mygamelive'} />
                        : <Redirect to={`/SkillLevel?logintype=player&accountName=${this.props.match.params.accountName}`} />)
                    : null}
                {
                   playerReports.hands >= 100 && Object.keys(playerReports).length > 0 &&
                    <div>
                        {this.state.reportSettingsOpen && (
                            <ReportCardFilter
                                i18next={i18next}
                                access={this.state.access}
                                levels={playerReports.playerLevels}
                                open={this.state.reportSettingsOpen}
                                saveSettings={() => this.saveSettings}
                                closeFilter={() => this.setState({ reportSettingsOpen: false })}
                                medalUrl={playerReports.summaryInfo[0].medal && ('//' + domain + '/images/Medals/' + (partyBrands.includes(this.state.brand) ? 'PartyPoker' + '/' + this.props.gameType : this.props.gameType) + '/' + playerReports.summaryInfo[0].medal.replace(/[^A-Z0-9-]/ig, "") + '/' + playerReports.summaryInfo[0].medal.replace(/[^A-Z0-9-]/ig, "") + '_' + playerReports.star + '.png')}
                            />
                        )}
                        <ShareDialog
                            i18next={i18next}
                            contentStyle={{ width: 300, maxWidth: "none" }}
                            title="Share hand replayer"
                            modal={true}
                            open={this.state.shareDialogOpen}
                            type={"image"}
                            message={"https://www.partypoker.com"}
                            image={this.state.screenshot}
                            trackData={this.state.shareTrack}
                            onRequestClose={this.onShareDiaogClose}
                        />
                       {!this.state.openSocialMediaDialog && <ShareReportCardModal 
                       i18next={i18next}
                        open ={this.state.openReportCardShareModal}
                        handleClose = {this.handleClose}
                        data ={this.state.shareObj}
                        medalUrl={playerReports.summaryInfo[0].medal && ('//' + domain + '/images/Medals/' + (partyBrands.includes(this.state.brand) ? 'PartyPoker' + '/' + this.props.gameType : this.props.gameType) + '/' + playerReports.summaryInfo[0].medal.replace(/[^A-Z0-9-]/ig, "") + '/' + playerReports.summaryInfo[0].medal.replace(/[^A-Z0-9-]/ig, "") + '_' + playerReports.star + '.png')}
                        analysisArray={this.state.selectedSummeryRange}
                        handleToggleSwith={this.handleToggleSwith}
                        level={playerReports.summaryInfo[0].medal}
                        score={playerReports.summaryInfo[0].points}
                        noOfHands={playerReports.hands}
                        onNextClick={this.onNextClick}
                        />}
                        <div style={{ backgroundColor: 'white', boxShadow: '0 2px 6px 2px rgba(0,0,0,0.09)' }}>
                            <div className="container" style={{ paddingTop: "30px", paddingBottom: "26px" }} >
                                {playerReports.summaryInfo.length > 0 && (
                                    <ReportHeading
                                    i18next={i18next}
                                        gameType={gameType}
                                        playerReports={playerReports}
                                        onSettingsClick={_ => this.setState({ reportSettingsOpen: true })}
                                        reportCardSetting={reportCardSetting.filter(reopFilter => reopFilter.gameType === gameType)[0]}
                                    />
                                )}
                               
                                <div className="grid report-stats">
                                    {medalsDetails &&
                                        starsDetails &&
                                        playerReports.summaryInfo[0].medal && (
                                            <ReportSummary
                                                domain={domain}
                                                i18next={i18next}
                                                stars={playerReports.star}
                                                starsDetails={starsDetails}
                                                medalsDetails={medalsDetails}
                                                noOfHands={playerReports.hands}
                                                gameType={playerReports.gameType}
                                                getShareId={(data) => this.getShareId(data)}
                                                level={playerReports.summaryInfo[0].medal}
                                                score={playerReports.summaryInfo[0].points}
                                                medalUrl={'//' + domain + '/images/Medals/' + (partyBrands.includes(this.state.brand) ? 'PartyPoker' + '/' + this.props.gameType : this.props.gameType) + '/' + playerReports.summaryInfo[0].medal.replace(/[^A-Z0-9-]/ig, "") + '/' + playerReports.summaryInfo[0].medal.replace(/[^A-Z0-9-]/ig, "") + '_' + playerReports.star + '.png'}
                                            />
                                        )}

                                    <div className="report_summary_wrapper">
                                        <span>
                                            {this.props.playerReports.mission && localStorage.getItem('userRole').indexOf('PLAYER') != -1
                                                && this.props.match.params.accountName === localStorage.getItem('accountName')
                                                && this.props.gameType === 'cash' && !this.props.loading
                                                && this.state.showMission ? <MissionAlert
                                                    i18next={i18next}
                                                    baseUrl={baseUrl}
                                                    loading={this.props.loading} apiService={apiService}
                                                    processHoleCards={processHoleCards}
                                                    saveActivity={saveActivity}
                                                    playerReports={playerReports}
                                                />
                                                :
                                                <span onClick={() => {
                                                    this.setState({ showMission: true })
                                                }}>
                                                    <ReportSummaryMessage i18next={i18next} summary={playerReports.summaryInfo[0].comment} gameType={gameType}/>
                                                </span>
                                            }
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container reportCardContainer">
                            <Paper className="paperCss myGameAnyBottom" >{playerReports.hands >= 100 && (
                                <ReportCardContent
                                    i18next={i18next}
                                    gameType={gameType}
                                    updatedAt={['Select', 'Today'].indexOf(hitRange) != -1 ? '' : playerReports.lastReportUpdatedDate}
                                    handsAnalysed={playerReports.hands}
                                    summaryInfo={playerReports.summaryInfo[0]}
                                    playerStatistics={playerReports.playerStats}
                                    summaryRange={playerReports.summaryRange}
                                    luckfactor={playerReports.luckfactor}
                                    accountName={this.state.accountName}
                                    saveActivity={saveActivity}
                                    //TODO remove temp hitRange
                                    hitRange={hitRange}
                                    saveCourseRedirection={this.saveCourseRedirection}
                                    path={`${this.props.location.pathname}?${queryString.stringify({
                                        fromDate, toDate, hitLevel, hitRange, hitType, accountName, shift,
                                        logintype: JSON.parse(localStorage.getItem('userRole')).indexOf('PLAYER') !== -1 ? 'player' : "admin",
                                    })}`}
                                />
                            )}
                            </Paper>
                        </div>
                    </div>
                }
                {playerReports.hands >= 100 && (
                    <div className="container reportCardContainer">
                         {this.props.potsLoading
                          ? <center>
                            <img id="loadingImg" height="50px" width="50px" src={Logo} alt="Loading..." />
                            <br></br>
                            <br></br>
                            <span style={{ fontFamily: "Roboto" }}> {i18next.t("loadingHands")} </span>
                          </center>
                            : 
                            <span>
                                <MediaQuery minWidth={1051}>
                                    <MyTopHandsWrapper
                                        i18next={i18next}
                                        desktopView={true}
                                        domain={"//" + domain}
                                        gameType={gameType}
                                        playerReports={playerReports}
                                        currency={playerReports.currency}
                                        setStarFlagOfHnad={this.setStarFlagOfHnad}
                                        handReplayerOpen={this.handReplayerOpen}
                                    />
                                </MediaQuery>
                                <MediaQuery maxWidth={1050}>
                                    <MyTopHandsWrapper
                                        i18next={i18next}
                                        desktopView={false}
                                        domain={"//" + domain}
                                        gameType={gameType}
                                        playerReports={playerReports}
                                        currency={playerReports.currency}
                                        setStarFlagOfHnad={this.setStarFlagOfHnad}
                                        handReplayerOpen={this.handReplayerOpen}
                                    />
                                 </MediaQuery>
                            </span>
                            }
                    </div>
                )}
                {!["Danskespil", "optibet"].includes(localStorage.getItem("loggedInType")) && playerReports.hands >= 100 ? (
                    <div className="container reportCardContainer">
                         {this.props.promotionalContent && 
                         <NewPromotionsWrapper
                            i18next={i18next}
                            domain={"//" + domain}
                            promotionalContent={this.props.promotionalContent}
                          />}
                    </div>
                  ): <div style={{paddingTop: "100px", width: "100%"}}></div>}
                {this.state.openHandRep ? (
                    <div
                        style={{
                            top: 0,
                            left: 0,
                            zIndex: 20000,
                            width: "100%",
                            height: "100%",
                            overflow: "auto",
                            position: "fixed",
                            backgroundColor: "#2c2c34"
                        }}
                    >
                        {fullVersion && parseFloat(fullVersion) < 13 ? (
                            <HandReplayer
                                // i18next={i18next}
                                replayerScreen={"desktop"}
                                gameTypeForTitle={gameType}
                                onClose={() => this.setState({ openHandRep: false })}
                                loginStatus={true}
                                toDate={toDate}
                                gameType={gameType}
                                fromDate={fromDate}
                                gameNo={this.state.gameNo}
                                accountName={playerReports.accountName}
                                playerAlias={playerReports.playerName}
                                partitionDate={this.state.partitionDate}
                            />
                        ) : (
                                <ReplayHand
                                    // i18next={i18next}
                                    replayerScreen={"desktop"}
                                    loginStatus={true}
                                    toDate={toDate}
                                    gameType={gameType}
                                    fromDate={fromDate}
                                    gameNo={this.state.gameNo}
                                    gameTypeForTitle={gameType}
                                    partitionDate={this.state.partitionDate}
                                    accountName={this.props.playerReports.accountName}
                                    playerAlias={this.props.playerReports.playerName}
                                    onClose={() => this.setState({ openHandRep: false })}
                                />
                            )}
                    </div>
                ) : (
                        <div></div>
                    )}
            </div >
        );
    }
}
const mapStateToProps = state => {
    return {
        loading: state.commonReducer.loading,
        potsLoading: state.commonReducer.isPromotional,
        gameType: state.multipleReportCards.gameType,
        reportCardSetting: state.multipleReportCards.reportCardSetting,
        missions: state.multipleReportCards.playerReports.missions,
        playerReports: state.multipleReportCards.playerReports,
        starsDetails: state.multipleReportCards.starsDetails,
        medalsDetails: state.multipleReportCards.medalsDetails,
        formData: state.form,
        promotionalContent: state.multipleReportCards.promotionalContent,
        multiGamePlayerReports: state.multipleReportCards.multiGamePlayerReports,
        lang: state.header.lang
    };
};


const mapDispatchToProps = dispatch => {
    return {
        setHeaderTitle: (newTitle) => dispatch(actions.setHeaderTitle(newTitle)),
        getOnLoadReportCardDtls: (playerReports) => dispatch(actions.getOnLoadReportCardDtls(playerReports)),
        setTopHands: (data) => dispatch(actions.setTopHands(data)),
        getSingleReportCardsDetails: (reportCardSetting) => dispatch(actions.getSingleReportCardsDetails(reportCardSetting))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(NewPlayerReportCard);


/** WEBPACK FOOTER **
 ** ./src/components/ReportCard/NewReporrCard/NewPlayerReportCard.js
 **/